module.exports = __webpack_public_path__ + "img/rca-rs-menu6.e5538c41.jpg";